/**
 * A list of possible JavaScript runtime types
 */
export var JavaScriptRuntimeType;
(function (JavaScriptRuntimeType) {
    /**
     * JavaScript running in a standard platform webview. This could be a headless webview (i.e., no visible UI)
     */
    JavaScriptRuntimeType["webView"] = "webView";
    /**
     * JavaScript running in a [JavaScriptCore](https://developer.apple.com/documentation/javascriptcore) context (i.e., JSContext). This is typically on Apple platforms.
     */
    JavaScriptRuntimeType["javaScriptCore"] = "javaScriptCore";
    /**
     * JavaScript running in a [JavaScriptEngine](https://developer.android.com/jetpack/androidx/releases/javascriptengine) context. This is typically on Android platforms.
    */
    JavaScriptRuntimeType["javaScriptEngine"] = "javaScriptEngine";
    /**
     * JavaScript running in a [V8](https://v8.dev/) runtime context.
    */
    JavaScriptRuntimeType["v8"] = "v8";
    /**
     * JavaScript running in a [hermes](https://github.com/facebook/hermes) runtime context.
    */
    JavaScriptRuntimeType["hermes"] = "hermes";
    /**
     * JavaScript running in a context not defined above.
    */
    JavaScriptRuntimeType["other"] = "other";
})(JavaScriptRuntimeType || (JavaScriptRuntimeType = {}));
//# sourceMappingURL=container.js.map